module.exports = __webpack_public_path__ + "img/Terraform-1-mobile.c5df0020.png";